export default {
    OurServices:'Layanan Kami',
    contentP:"Seeder terus mengembangkan layanan Kredit Skoring dan layanan profiling pelanggan. Anda dapat berlangganan melalui Seeder.",
   
    ServiceTypes:'Tipe Layanan',
    CreditScoreDevelopment:"Pengembangan Skor Kredit",
    contentP2:"Mengembangkan sistem penilaian kredit dengan dasar fondasi kuat dari histori kredit dan data alternatif untuk dapat mengukur lebih baik tingkat risiko dari pelanggan anda",
    SubscribeourscoringAPlviaSeeder:"Berlanggananlah APl Penilaian Skor Kredit kami melalui Seeder",
    contentP3:'Seeder berkonsep sistem manajemen pengguna, memungkinkan pengguna untuk dengan mudah berlangganan produk API',
    
    CreditScore: "Pengembangan Skor Kredit",
    DeepLearning:"Mempelajari Mendalam, Teknik “Learning Machine” Mempelajari Data Masif Untuk Memprediksi Skor Kredit",
    DeepLearningContent:"Sistem penilaian kredit kami menggabungkan histori kredit konvensional dan data alternatif untuk memiliki pandangan menyeluruh terhadap pelanggan agar dapat lebih akurat memprediksi profil risiko dari aplikasi pinjaman yang masuk.",
    Wecontinuously:"Kami terus meningkatkan dan menambahkan skor yang lebih relevan dari hasil eksplorasi dan pengembangan kami dengan menyempurnakan setiap langkah: menangkap data, memperbarui model, dan sistem pengukuran.",
    
    AlternativeData:"Data Alternatif Untuk Keputusan Finansial Yang Lebih Baik",
    Ourdatalayer:"Mekanisme data kami yang berlapis-lapis akan membantu lembaga keuangan dan mitra bisnis untuk memaksimalkan data alternatif, dengan persetujuan pengguna, untuk menghasilkan keputusan kredit.",
    xinyongtext1:"Lembaga Keuangan",
    xinyongtext2:"Dompet Elektronik",
    xinyongtext3:"Perdagangan Elektronik",
    xinyongtext4:"Data Perjalanan",
    xinyongtext5:"Agen Perjalanan Online",
    xinyongtext6:"Dan Sebagainya...",
    Thesedatawill:"Data tersebut selanjutnya akan digunakan sebagai salah satu ukuran kelayakan kredit. Kelayakan kredit didasarkan pada kesehatan keuangan, disiplin kredit, identitas, perilaku & preferensi, dan hubungan sosial",
    
    Download:"Laporan Kredit Demo Unduh",
};
